import { combineEpics } from 'redux-observable';
import { onLoadRoutingRulesDoneEpic } from './_epics/onLoadRoutingRulesDoneEpic.epic';
import { onUpdateRoutingRulesDoneEpic } from './_epics/onUpdateRoutingRulesDoneEpic.epic';
import { onValidateRoutingRulesDoneEpic } from './_epics/onValidateRoutingRulesDoneEpic.epic';
import { validateRoutingRulesEpic } from './_epics/validateRoutingRules.epic';

export const controllerRoutingRulesEpic = combineEpics(
  onLoadRoutingRulesDoneEpic,
  onUpdateRoutingRulesDoneEpic,
  onValidateRoutingRulesDoneEpic,
  validateRoutingRulesEpic,
);
